import image from "../../assets/images/About/peeling-useless-parts-jewelry.png";

const AboutTwoTextImage = () => {
  return (
    <section className="about_image_with_text_section">
      <div className="upper_image_with_text">
        <div className="text_con">
          <p className="OUR_STORY">OUR STORY</p>
          <h3>THE BEGINNING OF AN ERA</h3>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris
            scelerisque pulvinar tellus non pulvinar. Vestibulum pretium pretium
            cursus. Etiam osuere porta tincidunt. Maecenas id velit id velit
            tincidunt mollis sodales ut tortor. Maecenas at augue molestie,
            tristique mi ultricies, tincidunt magna. Suspendisse.
          </p>
          <p>
            sodales lorem pellentesque, congue enim id, rutrum nunc. Donec at
            lerisque magna, sed scelerisque nisi. Sed lobortis, massa at euismod
            volutpat, nulla urna aliquet turpis, imperdiet consequat ante mi eu
            nunc. Sed euismod erat a tincidunt fermentum.
          </p>
        </div>
        <div className="img_con">
          <img src={image} alt="" />
        </div>
      </div>
      <div className="bottom_image_with_text">
        <div className="img_con">
          <img src={image} alt="" />
        </div>
        <div className="text_con">
          <p className="OUR_STORY">OUR STORY</p>
          <h3>THE BEGINNING OF AN ERA</h3>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris
            scelerisque pulvinar tellus non pulvinar. Vestibulum pretium pretium
            cursus. Etiam osuere porta tincidunt. Maecenas id velit id velit
            tincidunt mollis sodales ut tortor. Maecenas at augue molestie,
            tristique mi ultricies, tincidunt magna. Suspendisse.
          </p>
          <p>
            sodales lorem pellentesque, congue enim id, rutrum nunc. Donec at
            lerisque magna, sed scelerisque nisi. Sed lobortis, massa at euismod
            volutpat, nulla urna aliquet turpis, imperdiet consequat ante mi eu
            nunc. Sed euismod erat a tincidunt fermentum.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutTwoTextImage;
